import React, { useState } from 'react';

function SurveyStepThree({ formData, onNext }) {
    const [trainingRating, setTrainingRating] = useState(formData.trainingRating || '');
    const [trainingComments, setTrainingComments] = useState(formData.trainingComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!trainingRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ trainingRating, trainingComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 1: Compliance & Training</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How adequate was the training you received for handling prescriptions and patient data securely? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`training-rating-${option}`}
                            name="trainingRating"
                            value={option}
                            checked={trainingRating === option}
                            onChange={() => setTrainingRating(option)}
                        />
                        <label htmlFor={`training-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={trainingComments}
                    onChange={(e) => setTrainingComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!trainingRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepThree;
